import React from 'react'
import { useState } from 'react'
import { GiHamburgerMenu } from "react-icons/gi";
import { Link, NavLink } from 'react-router-dom';
import logo from "../assets/cylogo.png";
import CareerPage from './career';



const Navbar = () => {

  const [navMenu, setNavMenu] = useState(false);

  const menuToggle = () => {
    setNavMenu(!navMenu);
  }

  const activeLink = ({ isActive }) =>
    isActive
      ? "text-[#fd02fd] font-semibold  border-cyan-400 m-1"
      : "hover:text-[#fd02fd] m-1";


  return (
    <header className="fixed top-0 left-0 w-full bg-[#070022] border-b border-white/10 z-50">

      <div className='px-6 py-3 w-full bg-transparent flex justify-between'>

        <Link to="/">
          <img
            src={logo}
            alt="Cybredge Logo"
            className="h-14 md:h-18 w-auto object-contain"
          />
        </Link>






        <div className='relative flex items-center gap-4 md:gap-8'>



          <nav
  className={`${navMenu
    ? "fixed top-[79px] left-0 right-0 bottom-0 bg-[#070022]/95 backdrop-blur-xl flex flex-col items-center justify-start gap-6 z-50 transition-all duration-300"
    : "hidden"
    } md:flex md:static md:h-auto md:flex-row md:bg-transparent md:backdrop-blur-0 text-lg gap-4 p-2 text-white font-thin`}
>

            <NavLink onClick={menuToggle} className={activeLink} to="/">Home</NavLink>
            <NavLink onClick={menuToggle} className={activeLink} to="/about">About</NavLink>
            <NavLink onClick={menuToggle} className={activeLink} to="/portfolio">Portfolio</NavLink>
            <NavLink onClick={menuToggle} className={activeLink} to="/blog">Blog</NavLink>
            <NavLink onClick={menuToggle} className={activeLink} to="/services">Services</NavLink>
            <NavLink onClick={menuToggle} className={activeLink} to="/team">Team</NavLink>
            <NavLink onClick={menuToggle} className={activeLink} to="/contact">Contact</NavLink>
            <NavLink onClick={menuToggle} className={activeLink} to="/CareerPage">Career</NavLink>
            <NavLink onClick={menuToggle} className={activeLink} to="/ceo-message">CEO Message</NavLink>
            
            <div className="relative group">

              {/* MAIN BUTTON */}
              {/* <button className="text-white hover:opacity-90 flex items-center gap-1 font-thin hover:text-[#fd02fd] hover:font-bold m-1"> 
              Services ▾
            </button>

            {/* GLASS DROPDOWN 
            <div
              className="
      absolute  hidden group-hover:block 
      mt-2 w-52 py-3 rounded-xl
      backdrop-blur-xl bg-white/10
      border border-white/20 shadow-lg
      transition-all duration-300 z-50
      justify-items-center items-center
      left-1/2 -translate-x-1/2
    "
            >
              <Link
                to="/web-development"
                className="block px-4 py-2 text-white hover:bg-white/20 rounded-lg transition"
              >
                Web Development
              </Link>

              <Link
                to="/cyber-security"
                className="block px-4 py-2 text-white hover:bg-white/20 rounded-lg transition"
              >
                Cyber Security
              </Link>

              <Link
                to="/ai-automation"
                className="block px-4 py-2 text-white hover:bg-white/20 rounded-lg transition"
              >
                AI Automation
              </Link>
            </div>*/}
            </div>

          </nav>
          {/* ÷\ <Link to ="/pricing"> 
        <button className='h-9 w-28 backdrop-blur-md hover:shadow-[0_0_20px_rgba(6,182,212,0.5)]
  text-white border border-white/20 rounded-xl shadow-lg hover:bg-white/20 transition-all duration-300'>
    Get Started
  </button></Link>*/}
          <div className='menu md:hidden text-white text-3xl z-[60]'>
            <button onClick={menuToggle}>
              {navMenu ? "✕" : <GiHamburgerMenu />}
            </button>
          </div>

        </div>
      </div >
    </header >
  )
}

export default Navbar